import { memo, type PropsWithChildren } from 'react'

import { SubSectionTitle } from '@/components/common/SubSectionTitle'

const InfoMarketDataListLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className="gap-2xs flex flex-col">
      <SubSectionTitle>Market Attributes</SubSectionTitle>
      {children}
    </div>
  )
}

export default memo(InfoMarketDataListLayout)
